/** Reserve the warning's geometry so a freshness transition cannot move nearby
 * prices, holdings or bot controls. Fresh/unknown slots contain no warning text. */
export function StaleMarketBadge({ stale }: { stale: boolean }) {
  return (
    <span className="inline-flex h-[21px] w-12 shrink-0 items-center" data-stale-market-slot="">
      {stale && (
        <span
          className="inline-block shrink-0 whitespace-nowrap rounded border border-amber-500/60 bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-400"
          title="Current price is not confirmed; new orders are unavailable until the feed confirms it"
        >
          STALE
        </span>
      )}
    </span>
  );
}
